import { render, staticRenderFns } from "./selfStatement.vue?vue&type=template&id=3b1df153&scoped=true"
import script from "./selfStatement.vue?vue&type=script&lang=js"
export * from "./selfStatement.vue?vue&type=script&lang=js"
import style0 from "./selfStatement.vue?vue&type=style&index=0&id=3b1df153&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1df153",
  null
  
)

export default component.exports